import React, { useCallback, useEffect, useState } from "react";
import styles from "../index.module.css";
import {
  CustomButton,
  CustomFileInput,
  CustomTextInput,
} from "../../../../components";
import AxiosInstance, { TokenService } from "../../../../services/Api";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import PopupModal from "../../../../components/PopupModal/PopupModal";

const AnnouncementInfoCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { ID } = location.state || {};
  const user = TokenService.getUser();
  const clientData = user?.client_data[0] || [];
  const school_id = clientData?.school_id || "";
  const userId = user?.id || 0;
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    name: "",
    content: "",
  });
  const [modalState, setModalState] = useState({
    open: false,
    type: "success", // "success" | "error"
    message: "",
    redirectPath: "",
  });

  useEffect(() => {
    if (ID) {
      fetchHallOfFame();
    }
  }, [ID]);

  const fetchHallOfFame = async () => {
    const data = {
      school_id: school_id,
      id: ID,
    };

    try {
      const res = await AxiosInstance.post(`/school/listAnnouncement`, data);
      if (res.data?.status) {
        const mappedRows = res.data.data.map((item) => ({
          id: item.id,
          name: item.subject,
          content: item.content,
        }));

        setFormData(mappedRows[0]);
      }
    } catch (error) {
      console.error("Failed to fetch hall of fame list", error);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = translations.errors.nameRequired;
    }
    if (!formData.content.trim()) {
      newErrors.content = translations.errors.contentRequired;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      if (ID) {
        const payload = {
          school_id: school_id,
          user_id: userId,
          subject: formData.name,
          content: formData.content,
          isActive: 1,
          updated_by: userId,
        };
        const response = await AxiosInstance.put(
          `/school/updateAnnouncement/${ID}`,
          payload,
        );
        if (response.data?.status) {
          setModalState({
            open: true,
            type: "success",
            message: response.data?.message,
            redirectPath: "/user/ViewAnnouncement",
          });
          setFormData({
            name: "",
            content: "",
          });
        } else {
          setModalState({
            open: true,
            type: "error",
            message: response.data?.message,
            redirectPath: "",
          });

          throw new Error(response.data?.message || "Message send failed");
        }
      } else {
        const payload = {
          school_id: school_id,
          user_id: userId,
          subject: formData.name,
          content: formData.content,
          isActive: 1,
          created_by: userId,
        };
        const response = await AxiosInstance.post(
          `/school/createAnnouncement`,
          payload,
        );
        if (response.data?.status) {
          setModalState({
            open: true,
            type: "success",
            message: response.data?.message,
            redirectPath: "/user/content-management",
          });
          setFormData({
            name: "",
            content: "",
          });
        } else {
          setModalState({
            open: true,
            type: "error",
            message: response.data?.message,
            redirectPath: "",
          });

          throw new Error(response.data?.message || "Message send failed");
        }
      }
    } catch (err) {
      console.error("Error sending message:", err);
    }
  };
  const handleCancel = () => {
    setFormData({
      name: "",
      content: "",
    });
    setErrors({});
    setFormData({
      name: "",
      content: "",
    });
    navigate("/user/content-management");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const { language, translations } = useSelector((state) => state.language);
  const handleSuccessOk = () => {
    const { type, redirectPath } = modalState;

    setModalState((prev) => ({
      ...prev,
      open: false,
    }));

    if (type === "success" && redirectPath) {
      navigate(redirectPath);
    }
  };

  return (
    <>
      <PopupModal
        open={modalState.open}
        title={modalState.type === "success" ? "Success" : "Failed"}
        message={modalState.message}
        onOk={handleSuccessOk}
      />

      <div className={styles.container}>
        {/* Header */}
        <div className={styles.header}>
          <i className="fa-solid fa-table-cells"></i>
          <h2 className={styles.title}>Announcements</h2>
        </div>
        <div className={styles.headerDivider}></div>

        {/* Form */}
        <form onSubmit={handleSubmit} className={styles.form}>
          {/* Row 1: School and Role */}
          <div className={styles.formRow}>
            <div className={styles.formGroup}>
              <CustomTextInput
                label={translations.labels.fullname}
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder={`${translations.labels.enter} ${" "}${translations.labels.fullname}`}
                required
                error={errors.name}
                maxLength={200}
              />
            </div>
          </div>

          {/* Row 2: Subject (full width on left) */}
          <div className={styles.formRow}>
            <div className={styles.formGroup}>
              <CustomTextInput
                label={translations.labels.content}
                name="content"
                value={formData.content}
                onChange={handleInputChange}
                placeholder={`${translations.labels.enter} ${" "}${translations.labels.content}`}
                required
                error={errors.content}
              />
            </div>
          </div>

          {/* Row 3: Message and Attachment - Aligned straight */}

          {/* Action Buttons */}
          <div className={styles.buttonGroup}>
            <CustomButton
              type="submit"
              variant="contained"
              className={styles.sendButton}
              fullWidth={false}
              // icon={<i className="fa-solid fa-paper-plane"></i>}
              iconPosition="left"
            >
              {translations.labels.save}
            </CustomButton>
            <CustomButton
              type="button"
              variant="contained"
              className={styles.cancelButton}
              fullWidth={false}
              onClick={handleCancel}
              // icon={<i className="fa-solid fa-circle-xmark"></i>}
              iconPosition="left"
            >
              {translations.labels.cancel}
            </CustomButton>
          </div>
        </form>
      </div>
    </>
  );
};

export default AnnouncementInfoCreate;
